interface CallWindowPayload {
  serverUrl: string;
  token: string;
  joinUrl: string;
  mode: "audio" | "video";
  channelName: string;
}

interface ParsedCallWindowPayload {
  payload: CallWindowPayload | null;
  error: string | null;
}

function isValidServerUrl(value: string): boolean {
  try {
    const parsed = new URL(value);
    const liveKitHost =
      parsed.hostname === "livekit.io" ||
      parsed.hostname.endsWith(".livekit.io") ||
      parsed.hostname === "livekit.cloud" ||
      parsed.hostname.endsWith(".livekit.cloud");
    if (liveKitHost) {
      return parsed.protocol === "wss:" || parsed.protocol === "https:";
    }
    return (
      parsed.protocol === "ws:" &&
      (parsed.hostname === "localhost" || parsed.hostname === "127.0.0.1")
    );
  } catch {
    return false;
  }
}

function isValidHttpUrl(value: string): boolean {
  try {
    const parsed = new URL(value);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}

export function parseCallWindowPayload(
  locationParams: string,
): ParsedCallWindowPayload {
  const params = new URLSearchParams(locationParams.replace(/^[?#]/, ""));
  const serverUrl = params.get("serverUrl")?.trim() ?? "";
  const token = params.get("token")?.trim() ?? "";
  const joinUrl = params.get("joinUrl")?.trim() ?? "";
  const mode = params.get("mode");
  const channelName = params.get("channelName")?.trim() || "channel";

  if (
    !serverUrl ||
    !token ||
    !joinUrl ||
    !mode ||
    !isValidServerUrl(serverUrl) ||
    !isValidHttpUrl(joinUrl) ||
    (mode !== "audio" && mode !== "video")
  ) {
    return {
      payload: null,
      error: "Missing or invalid call window parameters.",
    };
  }

  return {
    payload: { serverUrl, token, joinUrl, mode, channelName },
    error: null,
  };
}
